export default "__VITE_ASSET__901be119__"